
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    export class PsPriceOverrideReasonDialog extends Serenity.EntityDialog<PsPriceOverrideReasonRow, any> {
        protected getFormKey() { return PsPriceOverrideReasonForm.formKey; }
        protected getIsActiveProperty() { return PsPriceOverrideReasonRow.isActiveProperty; }
        protected getIdProperty() { return PsPriceOverrideReasonRow.idProperty; }
        protected getLocalTextPrefix() { return PsPriceOverrideReasonRow.localTextPrefix; }
        protected getNameProperty() { return PsPriceOverrideReasonRow.nameProperty; }
        protected getService() { return PsPriceOverrideReasonService.baseUrl; }
        protected getDeletePermission() { return PsPriceOverrideReasonRow.deletePermission; }
        protected getInsertPermission() { return PsPriceOverrideReasonRow.insertPermission; }
        protected getUpdatePermission() { return PsPriceOverrideReasonRow.updatePermission; }

        protected form = new PsPriceOverrideReasonForm(this.idPrefix);

        protected afterLoadEntity() {
            super.afterLoadEntity();

            // var Brandid = Q.tryFirst(CsSkuRow.getLookup().items,x => x.BrandCode == this.entity.BrandCode);
            // if(Brandid != null){
            //     // this.deleteButton.toggleClass('disabled', true);
            //     this.toolbar.findButton("delete-button").hide();
                
            // }
        }
    }
}